var m = require('mithril');
var layout = require('../layout/layout');
var ontology = require('./ontology');
var ontologyDetail = require('./ontologyDetail');


routes = {
  '/ontology': {
    view: function() {
      return m(layout, m(ontology));
    },
  },
  '/ontology/:class': {
    view: function() {
      return m(layout, m(ontologyDetail));
    },
  }
}


module.exports = routes;